<template>
    <el-container class="page_container">
        <el-aside :class="['page_aside', {'collapse': collapse}]">
            <div class="title">
                <transition name="transitionMenu">
                    <h1 v-show="!collapse">运营管理后台</h1>
                </transition>
            </div>

            <el-scrollbar class="page_aside_footer">
                <el-menu class="page_menu" :collapse="collapse" :collapse-transition="false" router :default-active="defaultActive" background-color="#001529" text-color="rgba(255, 255, 255, 0.65)" active-text-color="#FFF">
                    <el-submenu v-for="(route, i) in routers" :key="i" :index="route.path">
                        <template slot="title">
                            <i :class="route.meta.icon"></i>
                            <span>{{route.meta.title}}</span>
                        </template>
                        <template v-for="(item, j) in route.children">
                          <el-menu-item :key="j" :index="item.path" v-if="!item.meta.hidden && !item.meta.breadcrumbNoClick">{{item.meta.title}}</el-menu-item>
                          <el-menu :collapse="collapse" :collapse-transition="false" router :default-active="defaultActive" background-color="#001529" text-color="rgba(255, 255, 255, 0.65)" active-text-color="#FFF" :key="j" :index="item.path" v-if="!item.meta.hidden && item.meta.breadcrumbNoClick">
                            <el-submenu :index='item.path'>
                                <template slot="title">
                                    <i :class="item.meta.icon" style='color:transparent'></i>
                                    <span>{{item.meta.title}}</span>
                                </template>
                                <template v-for="(itemChild, k) in item.children">
                                    <el-menu-item :key="k" :index="itemChild.path" v-if="!itemChild.meta.hidden && !itemChild.meta.breadcrumbNoClick">{{itemChild.meta.title}}</el-menu-item>
                                </template>
                            </el-submenu>
                          </el-menu>
                        </template>
                    </el-submenu>
                </el-menu>
            </el-scrollbar>
        </el-aside>

        <el-container>
            <el-header class="page_header">
                <div class="page_header_head">
                    <img src="./../../assets/img/menu.png" :class="['iconBtn', {'collapse' : collapse}]" @click="collapse = !collapse"/>

                    <div>
                        <el-badge is-dot class="item" :hidden="!(noticeLength > 0)" style="margin-right: 20px">
                            <i class="el-icon-bell" style="font-size: 20px; cursor: pointer; color: rgba(0, 0, 0, 0.65)" @click="$router.push('/notice/list')"></i>
                        </el-badge>

                        <el-dropdown @command="handleCommand">
                            <div class="avatar_header">
                                <el-avatar :size="24" icon="el-icon-user-solid"></el-avatar>
                                <span class="name">{{userName}}</span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="change">修改密码</el-dropdown-item>
                                <el-dropdown-item command="exit">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>

                <transition name="transitionMenu" mode="out-in">
                    <div class="page_header_foot" :key="pageTitle">
                        <el-breadcrumb separator="/" class="breadcrumb">
                            <template v-for="(item, index) in breadcrumbList">
                                <el-breadcrumb-item :key="index" v-if="item.meta.breadcrumbNoClick">
                                    {{item.meta.title}}
                                </el-breadcrumb-item>
                                <el-breadcrumb-item :key="index" v-else-if="Number(index) === (breadcrumbList.length - 1)">
                                    <span>{{item.meta.title}}</span>
                                </el-breadcrumb-item>
                                <el-breadcrumb-item :key="index" :to="{ path: item.path }" v-else>
                                    {{item.meta.title}}
                                </el-breadcrumb-item>
                            </template>
                        </el-breadcrumb>
                        <h2 class="title">{{pageTitle}}</h2>
                    </div>
                </transition>
            </el-header>

            <el-main class="page_main">
                <el-scrollbar class="page_main_scroll">
<!--                    <transition name="transitionPageContent" mode="out-in">-->
<!--                        -->
<!--                    </transition>-->
                    <router-view />
                <div class="footer">
                  <img src="../../assets/img/ba.png" /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=22062102000190" rel="noreferrer" target="_blank">吉公网安备22062102000190号</a >
                </div>
                </el-scrollbar>
            </el-main>
            <el-dialog class="popup_dialog" title="修改当前密码" :visible.sync="password" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="600px">
              <el-form ref="formPwd" :model="formPwd" :rules="rulesPwd" label-width="120px" size="small">
                <el-form-item label="输入原密码：" prop="password">
                  <el-input v-model="formPwd.password" placeholder="请输入原密码" show-password></el-input>
                </el-form-item>
                  <el-form-item label="输入新密码：" prop="newPassword">
                    <el-input v-model="formPwd.newPassword" placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
        
                  <el-form-item label="确认密码：" prop="newPassWordAgain">
                    <el-input v-model="formPwd.newPassWordAgain" placeholder="请输入新密码" show-password></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" :loading="isSubmitLoading" @click="postPwd('formPwd')">提  交</el-button>
                      <el-button @click="password=false">关  闭</el-button>
                  </el-form-item>
              </el-form>
            </el-dialog>
        </el-container>
    </el-container>
</template>

<script>
  import {mapState} from "vuex";
  import {logout} from '@/api/public'
  import {postPassword} from "@/api";
  export default {
    name: "layout",
    data () {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formPwd.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        userName:'',
        defaultActive: '',
        collapse: false,
        breadcrumbList: [],
        routers: [],
        pageTitle: '',
        transitionName: '',
        isSubmitLoading:false,
        formPwd:{
          id:'',
          password:'',
          newPassword:'',
          newPassWordAgain:'',
        },
        password:false,
        rulesPwd: {
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          newPassword: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          newPassWordAgain: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
      }
    },
    watch: {
      $route (to, from) {
        if (!from.meta.index) {
          this.transitionName = "slide-left";
        }
        if (to.meta.index < from.meta.index) {
          this.transitionName = "slide-right";
        } else if (to.meta.index === from.meta.index) {
          this.transitionName = "slide-left";
        } else {
          this.transitionName = "slide-left";
        }
        this.getRouterDefault()
      }
    },
    computed: {
      ...mapState({
        noticeLength: state => state.app.noticeLength,
      })
    },
    mounted() {
      this.userName = localStorage.getItem('userName')
      const that = this
      window.onresize = () => {
        that.changeScreen()
      }
    },
    created () {

      let rules = JSON.parse(localStorage.getItem('userRole')).page
      let array=[]
      let newArray = this.$router.options.routes.filter(item => item.path !== '/');
      newArray[0].children.forEach((i)=>{
        let id = i.meta.id
        if (rules.indexOf(id)>=0) {
          array.push(i)
        }
      })
      newArray[0].children =array
      this.routers=newArray
      this.getRouterDefault();
      this.changeScreen();
    },
    methods: {
      postPwd(formName){
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.isSubmitLoading = true
            postPassword({
              data: this.formPwd
            }).then(res => {
              this.isSubmitLoading = false
              if (res.code === 0) {
                this.$message({
                  message: '修改密码成功,请重新登陆',
                  type: 'success',
                  showClose: true,
                });
                this.password = false
                logout().then(()=>{
                  localStorage.setItem('access_token', '')
                  if (localStorage.getItem('isShowUserName') != 'yes') {
                    localStorage.setItem('userName', '')
                  }
                  this.$router.replace('/')
                })
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          }
        })
      },
      getRouterDefault() {
        let defaultActiveList = this.$route.matched.filter(item => !item.meta.hidden)
        if (defaultActiveList.length > 0) {
          this.defaultActive = defaultActiveList[defaultActiveList.length - 1].path
        } else {
          this.defaultActive = ''
        }

        let breadcrumbList = this.$route.matched.filter(item => item.meta.breadcrumb)
        this.breadcrumbList = breadcrumbList
        this.pageTitle = breadcrumbList[breadcrumbList.length - 1].meta.title
      },
      changeScreen () {
        if (window.innerWidth < 1200) {
          this.collapse = true
        }
        if (window.innerWidth > 1200) {
          this.collapse = false
        }
      },
      handleCommand (command) {
        if (command === 'exit') {
          this.$confirm('是否确认退出登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            logout().then(()=>{
              localStorage.setItem('access_token', '')
              if (localStorage.getItem('isShowUserName') != 'yes') {
                localStorage.setItem('userName', '')
              }
              this.$router.replace('/')
            })
          }).catch(() => {});
        }
        if (command === 'change') {
          this.formPwd = {
            id: localStorage.getItem('userId'),
            password:'',
            newPassword:'',
            newPassWordAgain:'',
          }
          this.password = true
        }
      }
    },
    components: {}
  }
</script>
<style scoped lang="scss">
.footer{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  img{
    width: 22px; height: 22px;margin-right:4px;
  }
}
</style>